<script setup>
import { defineProps } from 'vue';
import { useRouter } from 'vue-router';
import Sheet from '../../Sheet.vue';

const props = defineProps({
    title: {
        type: String,
        required: false,
        default: ''
    },
    description: {
        type: String,
        required: false,
        default: ''
    },
    cardObjects: {
        type: Array,
        required: true,
        validator(value) {
            return value.every(
                (item) => (typeof item.icon === 'string' && typeof item.number === 'string') || ('number' && typeof item.title === 'string' && typeof item.description === 'string')
            );
        }
    }
});
const router = useRouter();

const navigateToLink = (link) => {
    if (link) {
        router.push(link);
    }
};
</script>

<template>
    <div class="w-full rounded-xl bg-white">
        <slot />
        <div v-if="props.title || props.description" class="flex flex-col mb-4">
            <p v-if="props.title" class="font-bold text-lg">{{ props.title }}</p>
            <p v-if="props.description" class="text-sm text-gray-500">{{ props.description }}</p>
        </div>

        <div class="flex-1 w-full">
            <div class="flex flex-col md:flex-row gap-3">
                <div
                    v-for="(card, index) in props.cardObjects"
                    :key="index"
                    class="flex flex-col items-center flex-1 bg-dashboard-primary-light p-6 rounded-xl"
                    :class="card.link ? 'cursor-pointer hover:bg-gray-200' : ''"
                    @click="card.link ? navigateToLink(card.link) : undefined"
                >
                    <div class="flex items-center justify-center gap-4">
                        <div v-if="card.icon" class="flex items-center justify-center text-blue rounded-full p-4 bg-white border border-blue/30 w-16 h-16">
                            <i v-if="card.icon?.includes('fi-')" :class="[card.icon, 'text-xl']"></i>
                            <img v-else-if="card.icon?.includes('hkcm/images/')" :src="card.icon" alt="icon" class="w-8 h-8 object-contain" />
                            <img v-else :src="card.icon" alt="icon" class="object-contain" />
                        </div>

                        <p class="font-bold text-xl text-black">{{ card.number }}</p>
                    </div>

                    <div class="flex flex-col items-center mt-2">
                        <p class="text-black text-center">
                            {{ $t(card.title) }}
                            <span v-if="card.symboleName">
                                :<br />
                                <strong>{{ card.symboleName }}</strong>
                            </span>
                        </p>
                        <p v-if="card.description" class="text-xxs text-gray-700 text-center mt-1">
                            {{ $t(card.description) }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
